module.exports = __webpack_public_path__ + "static/media/vwolves-logo.85b89f59.png";